import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';

const TmpHarmonisationOnboarding = {
	get(): boolean {
		return (
			// eslint-disable-next-line jira/ff/no-preconditioning
			expVal('board_harmonisation_software_tmp', 'isEnabled', false) &&
			fg('software-tmp-board-changeboarding')
		);
	},
};

export default TmpHarmonisationOnboarding;
